import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import history from '../../history'
import * as api from '../api/lead'
import { constants } from '../modules/leadDetails'

export function* fetchLeadDetails(action) {
  try {
    const payload = yield call(api.getLeadDetails, action.leadId)
    yield put({ type: constants.LEAD_DETAILS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_DETAILS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* leadDetailsRefresh() {
  yield takeLatest(constants.LEAD_DETAILS_REFRESH.ACTION, fetchLeadDetails)
}

function* sagaUpdateLeadDetails(action) {
  try {
    const payload = {
      lead_id: action.leadId,
      content: action.content
    }
    yield call(api.updateLeadDetail, payload)
    yield put({ type: constants.LEAD_DETAILS_UPDATE.SUCCESS, payload })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_DETAILS_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateLeadDetail() {
  yield takeLatest(constants.LEAD_DETAILS_UPDATE.ACTION, sagaUpdateLeadDetails)
}

function* sagaDeleteLead(action) {
  try {
    yield call(api.deleteLead, { leadId: action.leadId })
    yield put({ type: constants.LEAD_DELETE.SUCCESS })
    yield call(fetchLeadDetails, { leadId: action.leadId })
    history.push(`/leads/`)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteLead() {
  yield takeLatest(constants.LEAD_DELETE.ACTION, sagaDeleteLead)
}

function* sagaMarkAsDeadLead(action) {
  try {
    yield call(api.markAsDeadLead, { leadId: action.leadId, markAsAlive: action.markAsAlive })
    yield put({ type: constants.LEAD_MARK_AS_DEAD.SUCCESS })
    yield call(fetchLeadDetails, { leadId: action.leadId })
    history.push(`/leads/`)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_MARK_AS_DEAD.FAILED,
      message: e.message || e
    })
  }
}

function* watchMarkAsDeadLead() {
  yield takeLatest(constants.LEAD_MARK_AS_DEAD.ACTION, sagaMarkAsDeadLead)
}

function* sagaCloneLead(action) {
  try {
    yield call(api.cloneLead, { leadId: action.leadId, leadName: action.leadName })
    yield put({ type: constants.LEAD_CLONE.SUCCESS })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_CLONE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCloneLead() {
  yield takeLatest(constants.LEAD_CLONE.ACTION, sagaCloneLead)
}

export function* fetchLeadContracts(action) {
  try {
    const contracts = yield call(api.getLeadContracts, { leadId: action.leadId })
    yield put({ type: constants.FETCH_LEAD_CONTRACTS.SUCCESS, contracts })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.FETCH_LEAD_CONTRACTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchLeadContracts() {
  yield takeLatest(constants.FETCH_LEAD_CONTRACTS.ACTION, fetchLeadContracts)
}

function* sagaCreateJobFromLead(action) {
  try {
    const payload = {
      lead_id: action.leadId,
      content: action.content
    }
    yield call(api.createJobFromLead, payload)
    yield put({ type: constants.CREATE_JOB_FROM_LEAD.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_JOB_FROM_LEAD.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobFromLead() {
  yield takeLatest(constants.CREATE_JOB_FROM_LEAD.ACTION, sagaCreateJobFromLead)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(leadDetailsRefresh),
    fork(watchUpdateLeadDetail),
    fork(watchDeleteLead),
    fork(watchCloneLead),
    fork(watchFetchLeadContracts),
    fork(watchCreateJobFromLead),
    fork(watchMarkAsDeadLead)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/leadDetails.js